import { Info } from 'lucide-react';
import { useDashboardBanner } from '@/api/hooks';

// SS14: display-only Dashboard banner shown to everyone when an admin has enabled it.
// Admins edit it (toggle + message) on the Settings page. Neutral info style so it suits
// any message (a welcome as well as a reminder).
export function DashboardBanner() {
  const { data: banner } = useDashboardBanner();
  if (!banner?.enabled || !banner.message.trim()) return null;
  return (
    <div className="flex items-start gap-2 rounded-lg border border-info/40 bg-info/10 px-4 py-2.5 text-sm">
      <Info className="mt-0.5 h-4 w-4 shrink-0 text-info" />
      <span className="font-medium text-foreground">{banner.message}</span>
    </div>
  );
}
